export default "/static/webpack/media/uk-round.42fcd022.svg";